import { NextRequest, NextResponse } from 'next/server'
import { and, eq } from 'drizzle-orm'
import { cookies } from 'next/headers'
import { auth } from '@/auth'
import { PREFERRED_TENANT_COOKIE } from '@/auth'
import { db } from '@/db'
import { tenantMemberships, tenants } from '@/db/schema'

export async function POST(request: NextRequest) {
  const session = await auth()
  if (!session?.user?.id) {
    return NextResponse.json({ error: 'Unauthorized' }, { status: 401 })
  }

  const body = await request.json().catch(() => null)
  if (!body || typeof body.tenantId !== 'string' || !body.tenantId) {
    return NextResponse.json({ error: 'tenantId is required' }, { status: 400 })
  }

  const targetTenantId: string = body.tenantId

  // Verify the user has an active membership in the requested tenant
  const [membership] = await db
    .select({ tenantId: tenantMemberships.tenantId })
    .from(tenantMemberships)
    .where(
      and(
        eq(tenantMemberships.userId, session.user.id),
        eq(tenantMemberships.tenantId, targetTenantId),
        eq(tenantMemberships.isActive, true),
      )
    )
    .limit(1)

  if (!membership) {
    return NextResponse.json({ error: 'No active membership in that tenant' }, { status: 403 })
  }

  const [tenant] = await db
    .select({ name: tenants.name })
    .from(tenants)
    .where(eq(tenants.id, targetTenantId))
    .limit(1)

  const cookieStore = await cookies()
  cookieStore.set(PREFERRED_TENANT_COOKIE, targetTenantId, {
    httpOnly: true,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    maxAge: 60 * 60 * 24 * 90, // 90 days
    path: '/',
  })

  return NextResponse.json({ tenantId: targetTenantId, tenantName: tenant?.name ?? '' })
}
